import React, {useState, useEffect} from 'react'
import { Layout, Menu, Breadcrumb, Card } from 'antd';
import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';
import SideBar, {routes} from './sidebar'
import {Row, Col} from 'reactstrap'
import { Form, Input, Button, Table } from "antd";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { Firestore } from "../../config/firebase";

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;


export default function Users() {
  const [data, setData] = useState([]);


  useEffect(() => {
    async function fetchUpdates() {
      Firestore.collection("users")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setData(docs);
            }, 1000);
          });
        });
      }
      fetchUpdates();
    }, []);


    
  const columns = [
    {
      title: 'Name',
      dataIndex: 'displayName',
      key: 'displayName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
  
    {
      title: 'Action',
      key: 'Apply ',
      render: (text, record) => (
        <>
          {/* <Button
            className="btn-sm mt-2"
            outline
            type="primary"
          >
            Make Admin
        </Button>

        <Button
          className="btn-sm mt-2"
          outline
          type="danger"
          >
          Delete
        </Button> */}
        </>
      ),
    },
  ];


    return(
    
        <>
         
          <Card className="mt-3">


              Users
              <hr/>

              <Table columns={columns} dataSource={data} />
          </Card>
        </>
    
    
      
    )
}